import React, { useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

export default function ClientMinorModal({ show, onHide, onSave, initialData = {} }) {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm({
    mode: 'onTouched',
    defaultValues: {
      firstName: '',
      lastName: '',
      birthDate: '',
      relation: '',
      email: '',
      phone: '',
      notes: '',
      active: true,
      ...initialData
    }
  });

  useEffect(() => {
    if (show) reset({ firstName:'', lastName:'', birthDate:'', relation:'', email:'', phone:'', notes:'', active:true, ...initialData });
  }, [show, initialData, reset]);

  const submit = async (values) => {
    await onSave(values);
  };

  return (
    <Modal show={show} onHide={onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{initialData?.id ? 'Modifier un compte mineur' : 'Créer un compte mineur'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(submit)} noValidate>
        <Modal.Body>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group controlId="m-firstName">
                <Form.Label>Prénom *</Form.Label>
                <Form.Control
                  {...register('firstName', { required: 'Requis', maxLength: { value: 50, message: 'Max 50 caractères' } })}
                />
                {errors.firstName && <Form.Text className="text-danger">{errors.firstName.message}</Form.Text>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="m-lastName">
                <Form.Label>Nom *</Form.Label>
                <Form.Control
                  {...register('lastName', { required: 'Requis', maxLength: { value: 50, message: 'Max 50 caractères' } })}
                />
                {errors.lastName && <Form.Text className="text-danger">{errors.lastName.message}</Form.Text>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="m-birthDate" className="mt-2">
                <Form.Label>Date de naissance</Form.Label>
                <Form.Control type="date" {...register('birthDate')} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="m-relation" className="mt-2">
                <Form.Label>Lien</Form.Label>
                <Form.Control {...register('relation')} placeholder="Fils, Fille…" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="m-email" className="mt-2">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" {...register('email', { pattern: { value: /^\S+@\S+\.\S+$/, message: 'Email invalide' } })} />
                {errors.email && <Form.Text className="text-danger">{errors.email.message}</Form.Text>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="m-phone" className="mt-2">
                <Form.Label>Téléphone</Form.Label>
                <Form.Control {...register('phone', { pattern: { value: /^\+?[0-9]{8,15}$/, message: '8–15 chiffres' } })} />
                {errors.phone && <Form.Text className="text-danger">{errors.phone.message}</Form.Text>}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group controlId="m-notes" className="mt-2">
                <Form.Label>Notes</Form.Label>
                <Form.Control as="textarea" rows={2} {...register('notes')} />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Check type="switch" label="Actif" {...register('active')} className="mt-2" />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Annuler</Button>
          <Button type="submit" variant="primary" disabled={isSubmitting}>
            {initialData?.id ? 'Enregistrer' : 'Créer'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
